import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import $ from 'jquery'
//wowjs
import WOW from 'wowjs';
import 'wowjs/css/libs/animate.css';

import PrivateRoute from "./routes/ProtectedRoute";
import Index from "./frontend";
import AboutUs from "./frontend/pages/Aboutus"
import ContactUs from "./frontend/pages/Contactus"
import Gallary from "./frontend/pages/Gallary"
import Modules from "./frontend/pages/Modules"
import NewRegistration from "./frontend/pages/NewRegistration";
import Tearms from "./frontend/pages/Tearms";

import "./frontend/assets/js/main"
import OldStudents from "./frontend/pages/OldStudents";
import TermsAndCondition from "./frontend/component/PrivacyPolicy";
import PrivacyPolicy from "./frontend/component/PrivacyPolicy";
import OldStudentFnCom from "./frontend/pages/OldStudentFnCom";
import NewRegistrationFnCom from "./frontend/pages/NewRegistrationFnCom";

function App() {
  useEffect(() => {
    // Call componentDidMount logic here
    new WOW.WOW().init();

    //jquery Init Function
    if ($('.shape-mockup').length) {
      $('.shape-mockup').shapeMockup();
    }
    if ($('.vs-menu-wrapper').length) {
      $('.vs-menu-wrapper').vsmobilemenu();
    }
    if ($('.filter-menu').length) {
      $('.filter-menu').indicator();
    }

    if ($('.product-tab-style1').length) {
      $('.product-tab-style1').indicator();
    }

    if ($('.choose-tab').length) {
      $('.choose-tab').indicator();
    }
  }, []); // Empty dependency array to mimic componentDidMount

  return (
    <React.Fragment>
      <Router>
        <Routes>
          <Route path={process.env.PUBLIC_URL + "/"} element={<Index />} />
          <Route path={process.env.PUBLIC_URL + "/about-us"} element={<AboutUs />} />
          {/* <Route path={process.env.PUBLIC_URL + "/modules"} element={<Modules />} /> */}
          <Route path={process.env.PUBLIC_URL + "/contact-us"} element={<ContactUs />} />
          <Route path={process.env.PUBLIC_URL + "/gallary"} element={<Gallary />} />
          <Route path={process.env.PUBLIC_URL + "/terms-condition"} element={<Tearms />} />
          <Route path={process.env.PUBLIC_URL + "/new-registration"} element={<NewRegistrationFnCom />} />
          <Route path={process.env.PUBLIC_URL + "/old-registration"} element={<OldStudentFnCom />} />
          <Route path={process.env.PUBLIC_URL + "/privacy-policy"} element={<PrivacyPolicy />} />

          <Route element={<PrivateRoute />}>
            <Route path={process.env.PUBLIC_URL + "/index"} element={<Index />} />
          </Route>
        </Routes>
      </Router>
    </React.Fragment>
  );
}

export default App;
